import _ from 'lodash';

import { blobToBase64 } from 'utils/file';
import { logger } from 'utils/logger';
import { getIsNativePlatform } from 'utils/platform';

const ABSOLUTE_URL_REG_EX = /^(https?:|blob:|data:)/i;

const getBase64Payload = dataUrl => dataUrl.split(',').pop();

// Document file names are chosen by whoever uploaded the document — a broker submitting
// a task document, for one. Capacitor resolves writeFile's path relative to the target
// directory without rejecting traversal segments, so reduce to a bare basename.
const toSafeFileName = fileName =>
  String(fileName ?? '')
    .split(/[\\/]/)
    .pop()
    .replace(/^\.+/, '') || 'document';

export const getIsAbsoluteExternalUrl = url => _.isString(url) && ABSOLUTE_URL_REG_EX.test(url);

export const downloadOrShareBlob = async (blob, fileName) => {
  if (!getIsNativePlatform()) {
    const { downloadFileFromBlob } = await import('@lender/utils');

    return downloadFileFromBlob(blob, fileName);
  }

  try {
    const [{ Filesystem, Directory }, { Share }] = await Promise.all([
      import('@capacitor/filesystem'),
      import('@capacitor/share'),
    ]);

    const dataUrl = await blobToBase64(blob);
    const safeFileName = toSafeFileName(fileName);

    const { uri } = await Filesystem.writeFile({
      path: safeFileName,
      data: getBase64Payload(dataUrl),
      directory: Directory.Cache,
    });

    return Share.share({ title: safeFileName, url: uri });
  } catch (err) {
    logger.error(err);

    return null;
  }
};

export const openExternalUrl = async url => {
  if (!getIsNativePlatform()) {
    return null;
  }

  try {
    const { Browser } = await import('@capacitor/browser');

    return Browser.open({ url });
  } catch (err) {
    logger.error(err);

    return null;
  }
};
